import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@zvoove-market/shared';

export const hasAnalyticsGuard = (): CanActivateFn => () => {
  const router = inject(Router);
  const auth = inject(AuthService);
  return auth.$context().customer?.hasAnalytics || router.parseUrl('/page-not-found');
};
